import { render, staticRenderFns } from "./sesion.vue?vue&type=template&id=9623d632"
import script from "./sesion.vue?vue&type=script&lang=js"
export * from "./sesion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports